// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import FileSaver from 'file-saver'

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use( DatetimePicker );
//import Vuetify from 'vuetify'
//import 'vuetify/dist/vuetify.min.css'
//Vue.use( Vuetify );

import vuetify from '@/plugins/vuetify'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'tabulator-tables/dist/css/tabulator_simple.min.css';

import { Client } from '@stomp/stompjs';

import FeaturesSet from '@/utils/features'

const XLSX = require( "xlsx" );
window.XLSX = XLSX;

import {DateTime} from 'luxon'
window.DateTime = DateTime

//import * as d3 from 'd3';
//window.d3 = d3;

Vue.config.productionTip = false;

// Global event bus
Vue.prototype.$eventBus = new Vue(); 

if (window._TRUE_PLM_FEATURESET){
    FeaturesSet.init(window._TRUE_PLM_FEATURESET, localStorage);
}else{
    FeaturesSet.init({}, localStorage);
}

//Global app logic
import store from './store.js'
Vue.prototype.$globalStore = store;

Vue.prototype.$utils = {
    
    saveFile( blob, fileName, forDownload )
    {
          let userAgent = window.navigator.userAgent;
          if( forDownload || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || window.navigator.msSaveOrOpenBlob || blob.type === 'application/octet-stream' ) 
              FileSaver.saveAs( blob, fileName );
          else
          {
              let fileURL = URL.createObjectURL( blob );
              window.open( fileURL, '_blank' );                    
          } 
    },
    
    getAuthURL( prms )
    {
        let url = prms.auth_url + '?response_type=' + prms.response_type + '&scope=' + prms.scope 
            + '&client_id=' + prms.client_id + '&redirect_uri=' + prms.callback_url + '&state=' + prms.state;
           // + '&nonce=' + Math.floor( Math.random() * 1000000000 );
    
        return encodeURI( url );
    },
    
    getErrorText( info )
    {
        let err = info.split( '"' );
        for( let i = 0; i < err.length; i++ )
        {
            if( err[ i ].substring( 0, 5 ) !== 'ERROR' )
            {
                err = err[ i ];
                break;
            }
        }
        
        return err;
    },

    scrollTop( elID )
    {
        let el = document.getElementById( elID );
        if( el )
            el.scrollTop = 0;
    },

    focusInput( elem )
    {
        const el = elem.$el;     
        const input = el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])');
        if( input ) 
        {
            setTimeout( () => { input.focus() }, 0)
        }
    },
    
    openHelp( link )
    {
        link = process.env.BASE_URL + 'help/User%20Manual%20-%204.1.html#-' + link.replaceAll( '+', '-' );
        window.open( link, '_blank' );   
    },
    
    getURLData( str )
    {
        if( str )
        {
            let rg = /(?:(?:https?|ftp|http):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;
            let sRez = str.split( rg );
            if( sRez.length < 2 )
                return null;
            let mRez = str.match( rg );
//            console.log( sRez );
//            console.log( mRez );
            let rez = [];
            for( let i = 0; i < sRez.length; i++ )
            {
                rez.push( { val: sRez[ i ] } );
                if( i < mRez.length )
                {
                    if( mRez[ i ].substring( 0, 4 ) === 'www.' )
                        mRez[ i ] = 'http://' + mRez[ i ];
                    
                    rez.push( { val: mRez[ i ], isURL: true } );
                }
            }
            
            return rez;
        }
        return null;
    },

    isEmpty( obj )
    {
        if( !obj )
            return true;

        if( Array.isArray( obj ) )
            return obj.length < 1;

        for( const key in obj )
        {
            if( Object.hasOwn( obj, key ) )
                return false;
        }
        return true;
    },
    
    getEnum( data, addItem, notClear )
    {
        let enumVals = [];
        let doAdd = !!addItem;
        data.forEach( ( item ) =>
        {
            let txt = this.clearType( item );
            let val = txt;
            if( notClear )
                val = item;

            enumVals.push( { txt: txt, val: val } );
            if( item === addItem )
                doAdd = false;
        });
        if( doAdd )
        {
            let txt = this.clearType( addItem );
            let val = txt;
            if( notClear )
                val = addItem;
            enumVals.push( { txt: txt, val: val } );
        }
        this.sortArray( enumVals, ( a ) => ( a.txt ) );
        return enumVals;
    },
    
    getEnumClass( data )
    {
        let enumVals = [];
        data.forEach( ( item ) =>
        {
            enumVals.push( { txt: this.clearType( item ), val: item } );
        });
        this.sortArray( enumVals, ( a ) => ( a.txt ) );
        return enumVals;
    },

    getImage( inType, specType )
    {
        if( specType === 'shape' )
            return require( './assets/shape.png' );
        else if( specType === 'occurrence' )
            return require( './assets/occurrence.png' );
        
        if( inType )
        {
            var outType = this.clearType( inType ).toUpperCase();

            if( outType === 'PRODUCT_LIST' )
                outType = 'TRANSACTION';
            else if( outType !== 'MODULE' && outType !== 'SYSTEM' && outType !== 'SUBSYSTEM' )
                outType = 'UNIT';
            return require( './assets/' + outType + '.png' );             
        }
        else
            return require( './assets/file.png' );             
    },
    clearType( type )
    {
        if( !type )
            return type;
        
        if( typeof type !== 'string' )
            return type;
        
        let parts = type.split( ',' );
        let rez = [];
        parts.forEach( ( p ) =>
        {
            let t = p.split( ':' );
            if( t[ t.length - 1 ] !== '' )
                t = t[ t.length - 1 ];
            else
                t = t[ t.length - 2 ] + ':';
            t = t.split( '#' );
            t = t[ 0 ];
            t = t.split( '\.' );
            t = t[ t.length - 1 ];
            rez.push( t );
        });
        
        return rez.join( ', ' );
    },

    checkSymbols( str )
    {
        const regex = new RegExp( '[\:,\,,\;,\>,\|,\.]' );
        if( regex.test( str ) )
            return false;
        else
            return true;
    },

    isReadOnlyType( domains )
    {
        for( let i = 0; domains && i < domains.length; i++ )
        {
            if( domains[ i ] === 'urn:plcs:rdl:TruePLM:serial' || domains[ i ] === 'urn:plcs:rdl:TruePLM:counter'
                || domains[ i ] === 'urn:plcs:rdl:TruePLM:formatted_counter' 
                || domains[ i ] === 'urn:plcs:rdl:TruePLM:extended_counter'
                || domains[ i ] === 'urn:plcs:rdl:TruePLM:formatted_serial' )
                return true;
        }

        return false;
    },
    
    getRoleName( role, tr )
    {
        role = this.clearType( role );
        let rT = tr( 'message.user_role_name__' + role );
        if( rT === 'message.user_role_name__' + role )
        {
            rT = role.replace( '_', ' ' );
            rT = rT.substring( 0, 1 ).toUpperCase() + rT.substring( 1 );
        }
        return rT;
    },
    
    noGUID( type )
    {
        let t = type.split( '#' );
        return t[ 0 ];
    },
    
    unpackDate( date )
    {
        if( !date )
        {
            return null;
        }

        if( date < 0 )
        {
            date = date + 42949672956;
        }
        var sec = date & 0x3F;
        date >>= 6;
        var min = date & 0x3F;
        date >>= 6;
        var hour = date & 0x1F;
        date >>= 5;
        var day = date & 0x1F;
        date >>= 5;
        var month = date & 0x0F;
        date >>= 4;
        var year = date;

        return new Date( 1990 + year, month, day, hour, min, sec );
    },
    
    getStringDate( date )
    {
        var dt = new Date( date * 1000 );
        return ( this.addLeadZero( '' + dt.getDate() ) + '.' + this.addLeadZero( '' + ( dt.getMonth() + 1 ) ) + '.' + dt.getFullYear() + ' '
               + this.addLeadZero( '' + dt.getHours() ) + ':' + this.addLeadZero( '' + dt.getMinutes() ) + ':' + this.addLeadZero( '' + dt.getSeconds() ) );          
    },

    getISOLocaleStringDate( dt, dateOnly )
    {
        let rez = '' + dt.getFullYear() + '-' + this.addLeadZero( '' + ( dt.getMonth() + 1 ) ) 
                + '-' + this.addLeadZero( '' + dt.getDate() );
        
        if( dateOnly )
            return rez;

        rez += 'T'  + this.addLeadZero( '' + dt.getHours() ) + ':' + this.addLeadZero( '' + dt.getMinutes() ) 
                    + ':' + this.addLeadZero( '' + dt.getSeconds() );          
        return rez;
    },

    getPLMStringDateTime( dt )
    {
        let strDt = dt.toISOString();
        strDt = strDt.substring( 0, strDt.length - 5 );
        strDt = strDt.replace( 'T', ' ' );
        return strDt;     
    },
    
    getPLMStringDate( dt )
    {
        let strDt = dt.toISOString();
        strDt = strDt.substring( 0, strDt.length - 14 );
        strDt = strDt.replace( 'T', ' ' );
        return strDt;     
    },

    addLeadZero( val )
    {
        if( !val || val === '' )
          return '00';
        else if( val.length < 2 )
          return '0' + val;
        else
          return val;              
    },
    
    sortArray( arr, getVal, dec )
    {
        if( !arr || !arr.length || arr.length < 1 )
            return;
        
        if( !getVal )
            getVal = ( a ) => a;
        
        if( dec )
        {
            arr.sort( ( a, b ) => 
            {
                var aName = getVal( a ).toLowerCase();
                var bName = getVal( b ).toLowerCase();
                return ( ( aName < bName ) ? 1 : ( ( aName > bName ) ? -1 : 0 ) ); 
            });
        }
        else
        {
            arr.sort( ( a, b ) => 
            {
                var aName = getVal( a ).toLowerCase();
                var bName = getVal( b ).toLowerCase();
                return ( ( aName > bName ) ? 1 : ( ( aName < bName ) ? -1 : 0 ) ); 
            });  
        }
    },
    
    connectWS( ws_url, bus, gStore )
    {
        let socketURL = ws_url || "";
        if( 'ws://' !== socketURL.substring( 0, 5 ) && 'wss://' !== socketURL.substring( 0, 6 ) )
        {
            socketURL = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
            socketURL += window.location.host + window.location.pathname + ws_url;
        }
        console.log( 'Try to connect by websocket url=' + socketURL );

        let stompClient = new Client();
        stompClient.brokerURL = socketURL + 'iwebsocket';
        stompClient.heartbeatOutgoing = 20000;
        stompClient.heartbeatIncoming = 0;
        stompClient.reconnectDelay = 5000;

        stompClient.debug = function( str ){ console.log( str ); };

        stompClient.onConnect = function( frame )
        {		    	
            console.log( 'Websocket connected: ' + frame );

            stompClient.subscribe( '/user/queue/notifications', ( data ) =>
            {		        	
               // console.log( data );
                let info = JSON.parse( data.body );
                info.timestamp = Date.now();
         //       console.log( info );
                if( info.act === 'notify' )
                    gStore.procNotification( info.proj, info.task );
                else
                    bus.$emit( 'updateInfoMsg', info );   
            });
        };  
    
        stompClient.activate();

        return stompClient;
    },
    
    getFileBlob: function( aBuf, fName )
    {
        var fType = 'application/octet-stream';
        if( fName )
        {
            var nParts = fName.split( '.' );
            if( nParts.length > 1 )
            {
                var ext = nParts[ nParts.length - 1 ].toLowerCase();
                if( ext === 'pdf' )
                {
                    fType = 'application/pdf';
                }
                else if( ext === 'jpg' || ext === 'jpeg')
                {
                    fType = 'image/jpeg';
                }
                else if( ext === 'png' || ext === 'gif' || ext === 'bmp' || ext === 'tiff' )
                {
                    fType = 'image/' + ext;
                }
                else if( ext === 'txt' || ext === 'stp' || ext === 'step' )
                {
                    fType = 'text/plain';
                }
                else if( ext === 'xml' )
                {
                    fType = 'application/xml';
                }
            }
        }
        var blob = new Blob( [ aBuf ], { type: fType } );

        return blob;
    },
    
    transName( name )
    {
        if( !name )
            return name;
        
        name = name.replace( '_', ' ' );
        name = name.substring( 0, 1 ).toUpperCase() + name.substring( 1 );
        
        return name;
    },
    
    getRole( roles )
    {
        let rPrior = [ 'urn:rdl:epm-std:project_manager', 'urn:rdl:epm-std:project_admin',
            'urn:rdl:epm-std:project_leader', 'urn:rdl:epm-std:document_manager',
            'urn:rdl:epm-std:rdl_manager', 'urn:rdl:epm-std:project_member' ];
        
        for( let i = 0; i < rPrior.length; i++ )
        {
            for( let j = 0; j < roles.length; j++ )
            {
                if( roles[ j ] === rPrior[ i ] )
                    return rPrior[ i ];
            }
        }
        
        return null;
    },
    
    getLocalDateFromUTC( val, dateOnly )
    {
        if( !val )
            return null;
        
        if( dateOnly )
        {
            let d = new Date( val );
            return d.toLocaleDateString();
        }
        else
        {
            let d = new Date( val.replace( ' ', 'T' ) + 'Z' );
            return d.toLocaleString();
        }
    },
    
    getValByPath( obj, path )
    {
        let val = obj;
        if( !val || !path )
            return null;
        
        let pathParts = path.split( '.' );
        pathParts.forEach( p =>
        {
            val = val[ p ];
        });
        
        return val;
    },
    
    getPropType( domains )
    {
        let tView = null;
        for( let i = 0; domains && i < domains.length; i++ )
        {
            if( domains[ i ] === 'urn:plcs:rdl:TruePLM:Boolean' )  
                tView = 'B';
            else if( domains[ i ] === 'urn:owl:oneOf' )  
                tView = 'E';
            else if( domains[ i ] === 'urn:plcs:rdl:std:Date_time' )  
                tView = 'DT';
            else if( domains[ i ] === 'urn:plcs:rdl:TruePLM:Date' )  
                tView = 'D';
            else if( domains[ i ] === 'urn:plcs:rdl:TruePLM:Numeric_value' 
                        || domains[ i ] === 'urn:plcs:rdl:TruePLM:serial' 
                        || domains[ i ] === 'urn:plcs:rdl:TruePLM:counter'
                        || domains[ i ] === 'urn:plcs:rdl:TruePLM:formatted_counter' 
                        || domains[ i ] === 'urn:plcs:rdl:TruePLM:extended_counter'
                        || domains[ i ] === 'urn:plcs:rdl:TruePLM:formatted_serial' )  
                tView = 'N';
            else if( domains[ i ] === 'urn:plcs:rdl:TruePLM:List' )  
                tView = 'A';

            if( tView )
                break;
        }
        
        return tView;
    },
    
    isDerivedProp( types )
    {
        for( let i = 0; types && i < types.length; i++ )
        {
            if( types[ i ] === 'urn:plcs:rdl:TruePLM:Derived_property' )
                return true;
        }
        
        return false;
    },
    
    getDateFromStr( pVal, getUTC, dayEnd )
    {
        if( pVal.indexOf( ' ' ) > -1 )
            pVal = pVal.replace( ' ', 'T' );
        if( pVal.indexOf( 'T' ) < 0 )
        {
            if( getUTC )
            {
                if( dayEnd )
                    pVal += 'T23:59:59';
                else
                    pVal += 'T00:00:00';
            }
            else
                pVal += 'T20:00:00';    
        }

        return new Date( pVal );
    },

    procPropVal( pVal, tView )
    {
          if( pVal && ( tView === 'B' || tView === 'E' ) )
               pVal = this.clearType( pVal );

          if( pVal && tView === 'D' )
          {
              if( pVal.indexOf( ' ' ) > -1 )
                  pVal = pVal.replace( ' ', 'T' );
              else
                  pVal += 'T00:00:00';

              let d = new Date( pVal + 'Z' );
              pVal = d.toLocaleDateString();
          }

          if( pVal && tView === 'DT' )
          {
              if( pVal.indexOf( ' ' ) > -1 )
                  pVal = pVal.replace( ' ', 'T' );
              else
                  pVal += 'T00:00:00';

              let d = new Date( pVal + 'Z' );
              pVal = d.toLocaleString();
          }
                          
          return pVal;
    },
    merge( target, source ) 
    {
        Object.keys( source ).forEach( property => 
        {
            target[ property ] = source[ property ];
        });
    }
};

Vue.prototype.$modalDlg = {
    sysDlgs: {},
    state: {
        visNav: true
    },
    toggleNav()
    {
        this.state.visNav = !this.state.visNav;
    },
    hideNav()
    {
        this.state.visNav = false;
    }
};

//multilanguage support
import VueI18n from 'vue-i18n';
Vue.use( VueI18n );

const messages = {
  EN: {
    message: require( './assets/messages/en.msg' )
  },
  NO: {
    message: require( './assets/messages/no.msg' )
  }
};
const i18n = new VueI18n({
  locale: 'EN', // set locale
  messages: messages // set locale messages
});

/* eslint-disable no-new */

new Vue({
  vuetify,
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  i18n
});
